export const secondsToPercentage = (numOfSeconds: number) => {
  const secondsNum =
    typeof numOfSeconds !== 'number' ? Number(numOfSeconds) : numOfSeconds;
  return Array.from({ length: secondsNum }, (_, i) =>
    Math.ceil(((i + 1) / secondsNum) * 100)
  );
};

export const addZeroToDigit = (inNum: number) => {
  return inNum.toString().padStart(2, '0');
};
